'use client';

import type { ComponentType, PropsWithChildren, ReactNode } from 'react';
import { AfterEffectsMediaViewerConfigProvider } from '../../../aftereffects/components/AfterEffectsMediaViewerConfigProvider';
import { PremiereMediaViewerConfigProvider } from '../../../premiere/components/PremiereMediaViewerConfigProvider';
import { useUxpHostInfoContext } from '../../contexts/UxpHostInfoContext';
import {
  getValueForHost,
  type IntegrationHostMap,
} from '../../utils/integrationHostMap';

type HostMediaViewerConfigProviderProps = { children: ReactNode };

type HostMediaViewerConfigProviderComponent =
  ComponentType<HostMediaViewerConfigProviderProps>;

const HOST_MEDIA_VIEWER_CONFIG_PROVIDERS = {
  premiere: PremiereMediaViewerConfigProvider,
  aftereffects: AfterEffectsMediaViewerConfigProvider,
} satisfies IntegrationHostMap<HostMediaViewerConfigProviderComponent | null>;

export function HostMediaViewerConfigProvider({ children }: PropsWithChildren) {
  const { name: uxpHostName } = useUxpHostInfoContext();

  const Provider = getValueForHost(
    HOST_MEDIA_VIEWER_CONFIG_PROVIDERS,
    uxpHostName
  );

  if (!Provider) {
    return children;
  }

  return <Provider>{children}</Provider>;
}
